import { Formik } from "formik";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  TListingQueryParams,
  TPreLoginUserData,
} from "../../../api/store/commonSlice";
import { AdminFormFieldRadio } from "../../../components/admin/formFields";
import { LandingFormFieldSubmit } from "../../../components/landing/formFields";
import LandingWrapper from "../../../components/landing/landing";
import { routeUrls } from "../../../navigation/routeUrls";
import {
  formInitialValues,
  TFormFieldNames,
  YupValidationSchema,
} from "./validation";
import { useResendEmailOtpMutation } from "../../../api/network/authApiService";
import { serverErrorMessage } from "../../../api/network/errorCodes";
import { toast } from "react-toastify";
import svgIcons from "../../../assets/svg/svgIcons";

const ScreenSelect2FAMethod = () => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix: "select2FAMethodScreen",
  });
  const navigate = useNavigate();
  const listingQueryParams: TListingQueryParams = useSelector(
    (state: any) => state.commonReducer.listingQueryParams
  );
  const dispatch = useDispatch();

  // focus field on load
  const fieldRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    fieldRef.current?.focus();
  }, []);

  const preLoginUserData: TPreLoginUserData = useSelector(
    (state: any) => state.commonReducer.preLoginUserData
  );
  useEffect(() => {
    // if (!preLoginUserData?.email) {
    //   toast.error(t('toast.no_email'));
    //   navigate(routeUrls.loginPage);
    // }
  }, []);

  const [resendEmailOtpApiTrigger, { isLoading: isLoadingResendEmailOtp }] =
    useResendEmailOtpMutation();

  return (
    <LandingWrapper>
      <Formik
        initialValues={formInitialValues}
        validationSchema={YupValidationSchema}
        onSubmit={(values, { setSubmitting }) => {
          resendEmailOtpApiTrigger({
            email: preLoginUserData?.email || "",
            ...(values.mode_of === "via_mobile" && { phone: true || "" }),
          })
            .unwrap()
            .then(() => {
              // display success toast
              toast.success(
                t(
                  values?.mode_of === "via_mobile"
                    ? "toast.code_sent_mobile"
                    : "toast.code_sent_email"
                )
              );

              // redirect to verification screen
              navigate(
                values?.mode_of === "via_mobile"
                  ? `${routeUrls.verify2FA}/mobile/`
                  : `${routeUrls.verify2FA}/email/`
              );
            })
            .catch((error) => {
              toast.error(serverErrorMessage(error) || t("toast.code_send_failed"));
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          dirty,
          setFieldValue,
        }) => {
          const invalidFields = Object.keys(errors).filter(
            (key) => !!errors[key as TFormFieldNames]
          );
          const isFormValid = invalidFields.length === 0 && dirty;

          return (
            <form
              className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl"
              onSubmit={handleSubmit}
            >
              <h2 className="col-span-6 text-3xl font-bold text-heading-black">
                {t("heading")}
              </h2>

              <p className="col-span-12 mt-0 leading-relaxed text-gray-500">
                {t("sub_heading")}
              </p>
              <div className="col-span-12 mt-5 grid grid-cols-12">
                <AdminFormFieldRadio
                  label={t("via_mobile")}
                  name="mode_of"
                  id="via_mobile"
                  type="radio"
                  value={"via_mobile"}
                  checked={values?.mode_of === "via_mobile"}
                  onChange={(e) => {
                    setFieldValue("mode_of", e.target.value);
                  }}
                  customWrapperClass="col-span-6"
                  customLabelTextClass="ml-3 font-semibold"
                />

                <AdminFormFieldRadio
                  label={t("via_email")}
                  name="via_email"
                  id="via_email"
                  type="radio"
                  value={"via_email"}
                  checked={values?.mode_of === "via_email"}
                  onChange={(e) => {
                    setFieldValue("mode_of", e.target.value);
                  }}
                  customWrapperClass="col-span-6"
                  customLabelTextClass="ml-3 font-semibold"
                />
              </div>

              <div className="col-span-12 mt-5">
                {isLoadingResendEmailOtp ? (
                  <div className="flex justify-center">
                    <img
                      src={svgIcons.LoadingAnimation}
                      alt="Loading animation"
                      className="w-12 h-12"
                    />
                  </div>
                ) : (
                  <LandingFormFieldSubmit
                    label={t("submit_button")}
                    variant="primary"
                    disabled={isSubmitting}
                  />
                )}
              </div>
            </form>
          );
        }}
      </Formik>
    </LandingWrapper>
  );
};

export default ScreenSelect2FAMethod;
